import type { ReactElement } from 'react';
import type { MediaStorageDto } from '@gr/core/content/media/recompress';
import { useT } from '../../../../app/di';
import { formatFileSize } from '../../../../shared/format';
import styles from './BlogStorageFormats.module.scss';

/** PLAN-UC-5, MED-UC-8: компактная сводка по форматам блога — для профиля. */
export function BlogStorageFormats({ storage }: { storage: MediaStorageDto }): ReactElement {
  const { t, tp, locale } = useT();
  if (storage.formats.length === 0) return <p className="u-muted u-small">{t('media.storage.empty')}</p>;
  return (
    <ul className={styles.list}>
      {storage.formats.map((format) => (
        <li key={`${format.kind}:${format.ext}`} className={styles.item}>
          <span className={styles.ext}>{format.ext.toUpperCase()}</span>
          <span className="u-muted">
            {tp('media.storage.files', format.count, { n: format.count })} · {formatFileSize(format.bytes, locale)}
          </span>
        </li>
      ))}
    </ul>
  );
}
